import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "flex items-center bg-gray-800 px-8 py-6" }

import UserMenu from '../components/UserMenu.vue';
import DefaultSelect from '../components/DefaultSelect.vue';
import NetworkStatus from '../components/NetworkStatus.vue';
import DataSyncDialog from '../components/DataSyncDialog.vue';

import { useSelectCalculator } from '../composables/useSelectCalculator';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const { currentCalculatorId, options, selectCalculator } = useSelectCalculator();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      to: `/${_ctx.$route.params.calculatorId}`
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)
      ])),
      _: 1
    }, 8, ["to"]),
    _createVNode(DefaultSelect, {
      modelValue: _unref(currentCalculatorId),
      class: "ml-auto w-24 flex-initial",
      options: _unref(options),
      optionLabel: "version",
      optionValue: "id",
      "onUpdate:modelValue": _unref(selectCalculator)
    }, null, 8, ["modelValue", "options", "onUpdate:modelValue"]),
    _createVNode(NetworkStatus, { class: "mx-3" }),
    _createVNode(DataSyncDialog),
    _createVNode(UserMenu)
  ]))
}
}

})